"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useIsMounted", {
    get: ()=>_useIsMounted.useIsMounted,
    enumerable: true
});
const _useIsMounted = require("./useIsMounted");
